import { inject, InjectionToken } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  providedIn: 'root',
  factory: () => inject(AppConfigService).getApiBaseUrl(),
});